import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/ceLogo2.svg'


const _withScopeId = n => (_pushScopeId("data-v-082f049d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center h-screen px-6 bg-color-blue-gradient" }
const _hoisted_2 = { class: "w-full max-w-sm p-6 bg-white rounded-md shadow-md" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-center mb-10\" data-v-082f049d><span class=\"text-2xl font-semibold text-gray-700\" data-v-082f049d><img class=\"logo large-logo\" src=\"" + _imports_0 + "\" alt=\"logo image\" data-v-082f049d></span></div><h1 class=\"title mb-2\" data-v-082f049d>Code de validation Google</h1><p class=\"sub-title mb-4\" data-v-082f049d>Veuillez insérer votre code disponible dans l&#39;application (Google authenticator, Authy, Microsoft authenticator, Duo mobile ou autre) sur votre téléphone</p>", 3)
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = ["onUpdate:modelValue", "id", "onInput", "onKeydown"]
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, null, -1))
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = ["disabled"]

import {ref, computed} from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth/authStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckGoogle2FaCode',
  setup(__props) {

const router = useRouter();
const authStore = useAuthStore();

const code = ref(["", "", "", "", "", ""]);
const error = ref<string | null>(null);

const isCodeComplete = computed(() => {
    return code.value.every(digit => digit !== "");
});

const refs = {};
for (let i = 0; i < 6; i++) {
    refs[`input${i}`] = ref(null);
}

const focusNextInput = (event: InputEvent, inputIndex: number) => {
    if (event.target?.value.length === 1 && inputIndex < code.value.length) {
        const nextInput = `input${inputIndex + 1}`;
        const nextInputElement = document.getElementById(`${nextInput}`);
        if (nextInputElement) {
            nextInputElement.focus();
        }
    }
};

function focusPreviousInput(event: KeyboardEvent, inputIndex: number) {
    if ((event.key === 'Backspace' || event.key === 'Delete') && event.target?.value === '') {
        const previousInput = `input${inputIndex - 1}`;
        const previousInputElement = document.getElementById(`${previousInput}`);
        if (previousInputElement) {
            previousInputElement.focus();
        }
    }
}

const submitCode = async () => {
    const autCode = parseInt(code.value.join(''), 10);
    
    if (Math.abs(autCode).toString().length === 6) {
        error.value = null;
        
        try {
            const storedEmail = localStorage.getItem('userEmail') ?? '';
            const codeValidation = await authStore.verifyGoogle2faCode(autCode, storedEmail);
            if (
                codeValidation.data &&
                codeValidation.data.token &&
                codeValidation.data.refresh_token
            ){
                await router.push({ name: 'dashboard' });
            }
        } catch (errorResponse) {
            console.log(errorResponse);
            error.value = 'Le code est invalide.';
        }
    } else {
        error.value = "Le code doit comporter 6 chiffres.";
    }
}

function logout() {
    authStore.logout();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _withModifiers(submitCode, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(code.value, (input, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
              key: index,
              type: "text",
              "onUpdate:modelValue": ($event: any) => ((code.value[index]) = $event),
              maxlength: "1",
              id: `input${index}`,
              onInput: ($event: any) => (focusNextInput($event, index)),
              pattern: "[0-9]*",
              title: "Seuls les chiffres sont autorisés",
              oninvalid: "setCustomValidity('Seuls les chiffres sont autorisés')",
              oninput: "setCustomValidity('')",
              onKeydown: ($event: any) => (focusPreviousInput($event, index))
            }, null, 40, _hoisted_8)), [
              [_vModelText, code.value[index]]
            ])
          }), 128))
        ]),
        (error.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "btn btn-primary connect",
            type: "submit",
            disabled: !isCodeComplete.value
          }, "Se connecter", 8, _hoisted_12),
          _createElementVNode("button", {
            class: "btn btn-danger cancel-login",
            type: "button",
            onClick: logout
          }, "Annuler")
        ])
      ], 40, _hoisted_6)
    ])
  ]))
}
}

})